import React from 'react';
import { Button, Space } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { getUsersList } from '../../store/slices/userSlice';
import TableComponent from '../../components/TableComponent';
import { useNavigate } from 'react-router';
import { getJobs } from '../../store/slices/jobSlice';
import { formattedDateTime } from '../../store/slices/jobSlice';
import { getTimeSlots } from '../../store/slices/timeSlotSlice';

const TimeSlotList = () => {
    const navigate = useNavigate();
    const columns = [
        {
            title: 'Day',
            dataIndex: 'day',
            key: 'day',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Button onClick={() => navigate('/time_slot/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                    <Button onClick={() => navigate('/time_slot/view/' + data?._id)} icon={<EyeOutlined />} size="small">View</Button>
                    {/* <Button icon={<DeleteOutlined />} size="small" danger>Delete</Button> */}
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Time Slots</h1>
                <Button type="primary" onClick={() => navigate('/time_slot/add')}>Add Time Slot</Button>
            </div>
            <TableComponent
                listData={getTimeSlots}
                columns={columns}
                placeholder="Search Time Slot..."
            />
        </div>
    );
};

export default TimeSlotList;
